import { memo } from 'react';

import { Helmet } from 'react-helmet-async';

import useCreateSchema from './useCreateSchema';

import { JSONLinkedDataProps, SchemaType } from './types';

const JSONLinkedData = ({ data, type = SchemaType.Custom }: JSONLinkedDataProps) => {
  const dataToJson = useCreateSchema({ data, type });

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(dataToJson(data))}</script>
    </Helmet>
  );
};

// The additional assignment need to resolve the display name issue in eslint
const MemoizedComponent = memo(
  JSONLinkedData,
  // eslint-disable-next-line react/prop-types
  ({ type: prevType }, { type: nextType }) => prevType === nextType,
);
MemoizedComponent.displayName = 'JSONLinkedData';

export default MemoizedComponent;
